export default "__VITE_ASSET__DaXvOKXG__"